
<template>
	<div>
		<modal-content name="timeoutWarning" class="tw-relative" ref="timeoutModal">
		    <template #header>Session Timeout</template>
		    
		    <template #body>
		       Your session has been inactive for a while; you are about to be logged out.  Would you like to continue working?
		    </template>

		    <template #footer>
		        <div class="tw-flex tw-space-x-2 tw-justify-end">
		        	<button id="timeExtender" type="button" :disabled="btnDisabled" class="btn btn-primary" @click.prevent="extendTime">Extend time</button>
		        </div>
		    </template>
		</modal-content>
	</div>
</template>

<script>

export default {
	props: {
		lastActivity: {
			type: Number,
			required: true
		},
		sessionLength:{
			type: Number,
			required: true
		}
	},

	data() {
		return {
			lastTimeReset: this.lastActivity,
			warningTime: this.sessionLength - 300,
			timeout: null,
			channel: new BroadcastChannel('timeout-channel'),
			btnDisabled: false,
		}
	},

	mounted() {
		// Display a warning modal when the user has 5 minutes left
		setTimeout(this.giveWarning, this.warningTime * 1000);

		// Refresh the page when the timer runs out
		this.timeout = setTimeout(this.logout, this.sessionLength * 1000);

		console.log(this.channel);
		this.channel.addEventListener("message", e => {
			this.extendTime(true);
			console.log('extendingTime');
			console.log(e.data);
			
		});
		
		this.$nextTick( ()=> {
			this.channel.postMessage('page was changed/opened, extendTime on other pages');
		});
	},
	
	methods: {
		giveWarning(){
			EventBus.$emit('modal-custom', { name: 'timeoutWarning' });

			//console.log("GIVE WARNING: lastTimeReset, sessionLength, now: \n" + this.lastTimeReset + '\n' + this.sessionLength + '\n' + (Date.now() /1000));
			console.log("GIVE WARNING: lastTimeReset, now: \n"  + this.lastTimeReset + '\n' + (Date.now() /1000));
		},
		extendTime(fromChannel = false){
			//console.log('resetting warning time: ' + this.warningTime);
			var oldLastTime = this.lastTimeReset;
			
			if(fromChannel == true){
				// Reset logout timer
				clearTimeout(this.timeout);
				this.timeout = setTimeout(this.logout, this.sessionLength * 1000);

			}else{
				// SEND request to backend to extend 
				axios.post('/extendTimer')
					.then(response => {
						// RESET tracker of last activity
						this.lastTimeReset = response.data;
						console.log("EXTEND TIME: lastTimeReset(old and new), now: \n" + oldLastTime + '\n' + this.lastTimeReset + '\n' + (Date.now() /1000));

						// Reset logout timer
						clearTimeout(this.timeout);
						this.timeout = setTimeout(this.logout, this.sessionLength * 1000);
						this.channel.postMessage('extendTime');
						
					});
			}

			// RESET warning tracker
			setTimeout(this.giveWarning, this.warningTime * 1000);
			
			this.$refs.timeoutModal.close();
		},
		logout(){
			// document.getElementById('timeExtender').disabled = true;
			this.btnDisabled = true;
			setTimeout(window.location.replace('/login'), 1000);
		}

	}
}
</script>

<style>

</style>